const colors = {
    success: {
      dark: "#265a28",
      light: "#f6ffed"
    },
    error: {
      dark: "#ff4d4f",
      light: "#fff1f0"
    },
    warning: {
      dark: "#ffa39e",
      light: "#fff1f0"
    },
    info: {
      dark: "#1890ff",
      light: "#e6f7ff",
      medium: "#40a9ff"
    },
    white: {
      default: "#FFF"
    },
    primary: {
      light: "#f0f5ff",
      active: "#d2e0f9",
      medium: "#051871"
    },
    secondary: {
      default: "#00a7ff" //'#72c1ff',
    },
    grey: {
      default: "#95a2a2",
      tone1: "#aaa",
      tone2: "#bbb",
      tone3: "#ccc",
      tone4: "#ddd",
      tone5: "#eee",
      tone6: "#ececec",
      tone7: "#efefef"
    },
    disabled: {
      default: "#999"
    },
    active: {
      default: "#f2f2fb"
    }
  };
  
  const font = {
    family: {
      default: "AvenirNextCondensed_Regular",
      medium: "AvenirNextCondensed_Medium",
      light: "AvenirNextCondensed_UltraLight",
      bold: "AvenirNextCondensed_Demibold",
      italic: "AvenirNextCondensed_Italic"
    },
    size: {
      default: "18px",
      large: "24px",
      small: "14px"
    },
    color: {
      default: "#000",
      light: "#fff"
    }
  };
  
  const main = {
    background: {
      default: colors.primary.light,
      plain: colors.white.default
    },
    border: `1px solid ${colors.primary.light}`
  };
  
  const link = {
    color: colors.info.dark,
    hover: {
      color: colors.info.medium
    }
  };
  
  const player = {
    main: {
      primary: "#30567b",
      secondary: "#58b4bd",
      tertiary: "#16b781",
      color: "#fff",
      border: "1px solid #aaa",
      fontSize: "14px",
      largerFontSize: "18px",
      fontFamily: "tahoma, sans-serif",
      black: "#000",
      grey: "#95a2a2",
      buttonBg: "#8799a4",
      dangerDark: "#790d0d"
    },
    window: {
      border: "5px ridge #ddd",
      fontFamily: '"Oxygen Mono", Monaco, monospace',
      fontSize: "12px",
      title: {
        background: "#ddd"
      }
    }
  };
  
  export default {
    colors,
    font,
    main,
    link,
    player
  };
  